import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-renderer',
  templateUrl: './download-delete-button-renderer.component.html',
  styleUrls: ['./download-delete-button-renderer.component.scss']
})

export class DownloadDeleteButtonRendererComponent implements ICellRendererAngularComp {

  params;
  label: string;
  disabledCreate = false;


  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    //this.disabledCreate = (params.valueFormatted ? params.valueFormatted : params.value) !== '';
    
  }

  refresh(params?: any): boolean {
    return true;
  }

  onDownload($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        type: 'Download'
      };
      this.params.onClick(params);
    }
  }

  onDelete($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        type: 'Delete'
      };
      this.params.onClick(params);
    }
  }
}
